import style from './Samples.module.css';

import outSVG from 'assets/svg/sm_out-01.svg';
import intoSVG from 'assets/svg/sm_into-01.svg';
import refreshIcon from 'assets/svg/refresh-01.svg';

import { useContext, useEffect, useState } from 'react';
import { modeContext } from '../../../Contexts/contexts';
import { observer } from 'mobx-react-lite';
import ModalDefreeze from '../../../Modals/ModalDefreeze/ModalDefreeze';
import Tooltip from 'ui/Tooltip';
import Icon from 'ui/Icon';
import { storageStore } from 'store/mobx/storage.store';
import RegularButton from 'ui/RegularButton';
import ModalSelectDevices from 'components/Modals/ModalSelectDevices/idnex';
import { treeStore } from 'store/mobx/tree.store';

const Header = observer(({ pack }) => {
  const { mode } = useContext(modeContext);
  const { selectedSamplesForCopy, sensors, refreshSamples } = storageStore;
  const { selectedNode } = treeStore;

  const [sharedFilter] = useState(mode.sharedFilter);
  const [defreezeModal, setDefreezeModal] = useState({ show: false, type: null });
  const [deviceModal, setDeviceModal] = useState({ show: false, data: null });

  useEffect(() => {
    mode.setSharedFilter(sharedFilter);
  }, [sharedFilter]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div className={style.headerContainer}>
        <div className={style.headerName}>{pack.name}</div>
        <div className={style.headerActions}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '220px',
            }}
          >
            {pack.entity === 'storage' && (
              <RegularButton
                text={'Привязать оборудование'}
                variant={'flat'}
                onClick={() => {
                  setDeviceModal({ show: true, data: selectedNode });
                }}
              />
            )}
          </div>
          <div
            className={style.actionIconButton}
            onClick={() => setDefreezeModal({ show: true, type: 'out' })}
          >
            <Tooltip text={'Достать из хранилища'}>
              <Icon src={outSVG} width={'53px'} height={'53px'} />
            </Tooltip>
          </div>
          <div
            className={style.actionIconButton}
            onClick={() => setDefreezeModal({ show: true, type: 'into' })}
          >
            <Tooltip text={'Вернуть в хранилище'}>
              <Icon src={intoSVG} width={'53px'} height={'53px'} />
            </Tooltip>
          </div>
          <div
            className={style.actionIconButton}
            onClick={async () => {
              await refreshSamples();
            }}
          >
            <Tooltip text={'Обновить'}>
              <Icon
                src={refreshIcon}
                style={{
                  padding: '0 0 0 10px',
                }}
                width={'30px'}
                height={'30px'}
              />
            </Tooltip>
          </div>
        </div>
        {defreezeModal.show && (
          <ModalDefreeze
            mode={mode}
            defreeze={defreezeModal}
            setDefreeze={setDefreezeModal}
            sampleIds={selectedSamplesForCopy}
          />
        )}

        {deviceModal.show && (
          <ModalSelectDevices
            open={deviceModal.show}
            onClose={() => {
              setDeviceModal({ show: false, data: null });
            }}
            data={deviceModal.data}
          />
        )}
      </div>
      {selectedNode?.devices?.length > 0 && (
        <div className={style.devicesContainer}>
          {selectedNode?.devices?.map((device, index) => {
            const showT = sensors?.find((i) => i.id === device?.id_sensor)?.value?.t;
            const showH = sensors?.find((i) => i.id === device?.id_sensor)?.value?.h;

            return (
              <div key={index} className={style.device}>
                <div className={style.deviceLine}>
                  <div className={style.ellipsis}>{device?.name}</div>
                  <div className={style.deviceInv}>
                    <div>(инв.</div>
                    <div
                      style={{
                        marginLeft: '0.5rem',
                      }}
                      className={style.ellipsis}
                    >
                      {device?.inventory_number}
                    </div>
                    )
                  </div>
                </div>
                {(showH || showT) && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        background: 'var(--bs-blue)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                      }}
                    >
                      {device?.id_sensor}
                    </div>
                    <div className={style.sensorLine}>
                      {showT && (
                        <div className={style.sensorValues}>
                          <div>Датчик температуры:</div>
                          <span
                            style={{
                              fontWeight: '500',
                              fontSize: '15px',
                            }}
                          >
                            {showT} °C
                          </span>
                        </div>
                      )}
                      {showH && (
                        <div className={style.sensorValues}>
                          <div>Датчик влажности:</div>
                          <span
                            style={{
                              fontWeight: '500',
                              fontSize: '15px',
                            }}
                          >
                            {sensors?.find((i) => i.id === device?.id_sensor)?.value?.h} %
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
});

export default Header;
